<template>
  <div>
    <ClientOnly>
      <Modals/>
    </ClientOnly>

    <!-- navbar -->
    <NavBar v-if="showNavBar"/>

    <main class="main">
      <slot/>
    </main>

    <MarketplaceFooter v-if="showMarketplaceFooter" />

    <ClientOnly>
      <Snackbar/>
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import ClientOnly from '@/components/SSR/ClientOnly.vue'
import { Capacitor } from '@capacitor/core'
import Modals from '@/components/Modals/Modals.vue'
import MarketplaceFooter from '@/components/Navigation/Footer/MarketplaceFooter.vue'
import NavBar from '@/components/Navigation/NavBar/NavBar.vue'
import Snackbar from '@/components/Snackbar/Snackbar.vue'

const route = useRoute()

const showMarketplaceFooter = computed(() => {
  if (Capacitor.isNativePlatform()) {
    return false
  }

  const routeName = String(route.name)

  return !routeName.includes('checkout') && !routeName.includes('establishment') && !routeName.includes('thanks')
})

const showNavBar = computed(() => {
  // If we are not on a page, don't show the navbar
  if (!route.name) return false

  // Don't show the navbar on the homepage
  if (route.name.includes('home')) return false

  // Show the navbar everywhere else
  return true
})
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
}
</style>
